<img *ngIf="fileType===FileType.IMAGES" [src]="fileUrl" alt="preview" width="auto" height="100%">
<video *ngIf="fileType===FileType.VIDEOS" class="video-custom" width="auto" height="98%" controls>
  <source [src]="fileUrl" type="video/mp4">
  Your browser does not support the video tag.
</video>
<iframe (load)="loadedIframe($event)" *ngIf="fileType===FileType.DOCS || fileType===FileType.YOUTUBE ||isDocument" [src]="fileUrl | safeSrc" style="border:0;width:100%; height:calc(100% - 15px);"></iframe>
<p *ngIf="isFileNotSupport">
  Couldn't preview file!
</p>
